module.exports = __webpack_public_path__ + "img/better-squad.24eae571.jpg";